import { EVENTS_URL, STATS_URL } from '../constants';
import { apiSlice } from './apiSlice';

export const productEventsApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createEvent: builder.mutation({
            query: (data) => ({
                url: EVENTS_URL,
                method: 'POST',
                body: Array.isArray(data) ? data : [data],
            }),
        }),
        recomputeStats: builder.mutation({
            query: (data) => ({
                url: `${STATS_URL}/recompute`,
                method: 'POST',
                body: data,
            }),
        }),
    }),
});

export const { useCreateEventMutation, useRecomputeStatsMutation } = productEventsApiSlice;
